export default {
    getOnlyApp: (state) => {
        if (state.accounts.totalSize === 1) {
            return state.accounts.values[0].name;
        }

        return '';
    },
};
